import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/pages/gerenciadorContratos'

const initialState = {
  search: '',
  searchFilters: ['adf', 'matricula', 'nome', 'cpf', 'contratoConvenio', 'numeroAdfAntigo'],
  statusFilters: ['ATIVO', 'MINHAS_PENDENCIAS']
}

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  const mergeState = R.mergeRight(prevState)

  const addIn = listName =>
    R.compose(
      mergeState,
      R.assoc(listName, R.__, []),
      R.append(R.__, R.prop(listName, prevState))
    )

  const removeIn = listName =>
    R.compose(
      mergeState,
      R.assoc(listName, R.__, []),
      R.without(R.__, R.prop(listName, prevState))
    )

  const toggleIn = R.curry((listName, filter) =>
    R.ifElse(R.contains(R.__, R.prop(listName, prevState)), removeIn(listName), addIn(listName))(filter)
  )

  const setIn = listName =>
    R.compose(
      mergeState,
      R.assoc(listName, R.__, {}),
      R.append(R.__, '')
    )

  switch (action.type) {
    case actionTypes.SET_SEARCH:
      return mergeState({ search: action.search })
    case actionTypes.TOGGLE_SEARCH_FILTER:
      return toggleIn('searchFilters', action.searchFilter)
    case actionTypes.TOGGLE_STATUS_FILTER:
      return toggleIn('statusFilters', action.statusFilter)
    case actionTypes.ADD_STATUS_FILTER:
      return addIn('statusFilters')(action.statusFilter)
    case actionTypes.REMOVE_STATUS_FILTER:
      return removeIn('statusFilters')(action.statusFilter)
    case actionTypes.SET_STATUS_FILTER:
      return setIn('statusFilters')(action.statusFilter)
    case actionTypes.CLEAR_FILTERS:
      return initialState
    default:
      return prevState
  }
}
